<template>
  <div>
    <div class="wrap-document">
      <div class="page">
        <p class="title">
          Fitur dan Tarif <br />
          Tabungan Icon
        </p>
        <div class="content">
          <table class="table">
            <thead class="thead-light">
              <tr>
                <th colspan="2">Fitur Produk</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Deskripsi Produk</td>
                <td>Tabungan Icon</td>
              </tr>
              <tr>
                <td>Tipe Produk</td>
                <td>Tabungan</td>
              </tr>
              <tr>
                <td>Mata Uang</td>
                <td>IDR</td>
              </tr>
              <tr>
                <td>Media Pencatatan</td>
                <td><i>e-stattment</i></td>
              </tr>
              <tr>
                <td>Fasilitas ATM</td>
                <td>Ada</td>
              </tr>
              <tr>
                <td>Fasilitas Mobile Banking</td>
                <td>Ada</td>
              </tr>
            </tbody>
            <thead class="thead-light">
              <tr>
                <th colspan="2">Tarif Produk</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Setoran Awal</td>
                <td>100.000</td>
              </tr>
              <tr>
                <td>Saldo Minimum</td>
                <td>100.000</td>
              </tr>
              <tr>
                <td>Setoran Selanjutnya</td>
                <td>10.000</td>
              </tr>
              <tr>
                <td>Biaya Administrasi Bulanan</td>
                <td>7.500</td>
              </tr>
              <tr>
                <td>Denda dibawah Saldo Minimum</td>
                <td>0</td>
              </tr>
              <tr>
                <td>Rekening tidak bermutasi selama 6 bulan</td>
                <td>5.000</td>
              </tr>
              <tr>
                <td>Biaya Penutupan Tabungan</td>
                <td>100.000</td>
              </tr>
              <tr>
                <td>Biaya administrasi bulanan kartu ATM</td>
                <td>Sesuai jenis kartu ATM</td>
              </tr>
              <tr>
                <td>Suku Bunga</td>
                <td>0,25% p.a(dapat berubah sewaktu-waktu</td>
              </tr>
            </tbody>
          </table>
          <form>
            <div class="form-group">
              <!-- <label>Saya sudah membaca dan memahami</label>
                      <input type="checkbox" checked required> -->
            </div>
          </form>
        </div>
        <p class="title " style="margin-top:100px">
          SYARAT-SYARAT UMUM TABUNGAN <br />
          PT BANK ARTHA GRAHA INTERNATIONAL Tbk.
        </p>
        <div class="content">
          <ol>
            <li class="menu">
              REKENING TABUNGAN
              <ol type="a" class="sub-menu">
                <li>Bank akan menatausahakan penarikan dan penyetoran tabungan ke dalam rekening tabungan.</li>
                <li>
                  Rekening tabungan (account statement) akan dikirimkan setiap awal bulan ke alamat Penabung yang diketahui oleh Bank, kecuali ditentukan lain.
                </li>
              </ol>
            </li>
          </ol>
        </div>
        <div class="footer">
          <p></p>
          <p>1</p>
          <p></p>
        </div>
      </div>
    </div>
    <div class="wrap-document">
      <div class="page">
        <div class="content">
          <ol start="2">
            <li class="menu">
              PENYETORAN DAN PENARIKAN
              <ol type="a" class="sub-menu">
                <li>
                  Penyetoran dan penarikan dapat dilakukan bebas setiap saat pada waktu jam kerja selama kas buka atau setiap saat (24 jam X 7 hari) pada system ATM
                  (*Untuk Setoran, bila sistem ATM tersedia dan nasabah memenuhi syarat memiliki fasilitas ATM).
                </li>
                <li>Penyetoran dapat dilakukan dalam bentuk tunai, pemindahbukuan, warkat Bank dan atau warkat kliring.</li>
                <li>
                  Bank hanya akan melakukan pembayaran apabila tanda tangan Penabung sesuai dengan contoh tanda tangan terakhir yang ada pada Bank. Apabila ada
                  perubahan tanda tangan dan alamat maka Penabung diwajibkan untuk memberitahukan secara tertulis kepada Bank.
                </li>
                <li>
                  Apabila tanda tangan pada slip penarikan berbeda dengan tanda tangan pada buku tabungan, Penabung harus menunjukkan kartu identitas asli.
                </li>
              </ol>
            </li>
            <li class="menu">
              BUNGA
              <ol type="a" class="sub-menu">
                <li>
                  Bank menetapkan besarnya suku bunga tabungan dan apabila terjadi perubahan suku bunga, maka perubahan tersebut akan diberitahukan kepada Penabung
                  dalam bentuk dan cara yang ditetapkan oleh Bank.
                </li>
                <li>Bunga atas rekening tabungan dikenakan pajak sesuai dengan peraturan pemerintah yang berlaku.</li>
              </ol>
            </li>
            <li class="menu">
              PENGETAHUAN HUBUNGAN TABUNGAN
              <ol type="a" class="sub-menu">
                <li>
                  Penabung berhak untuk menghentikan hubungan rekening tabungan dengan pemberitahuan secara tertulis, kecuali jika ada persetujuan tertulis atau
                  peraturan lain. Tanggal efektif penutupan rekening berlaku pada hari yang ditetapkan dalam pemberitahuan tertulis tersebut. Atas penutupan rekening
                  dikenakan biaya administrasi sesuai tarif yang berlaku.
                </li>
                <li>
                  Bank secara sepihak berdasarkan pertimbangannya sendiri atau dengan adanya instruksi dari instansi yang berwenang berhak memblokir/menutup rekening
                  tanpa pemberitahuan atau persetujuan lebih dulu dari Penabung jika rekening tersebut disalahgunakan, tapi tidak terbatas untuk menampung dan atau
                  untuk melakukan kejahatan atau untuk kegiatan-kegiatan yang dapat merugikan masyarakat atau pihak manapun dan atau Bank atau rekening tidak aktif
                  (6 bulan tidak bertransaksi dan bersaldo di bawah saldo minimum atau nihil) atau berdasarkan alas an dan pertimbangan lain yang semata-mata
                  ditetapkan oleh Bank. Dengan ini Penabung telah memberikan kuasa untuk penutupan rekening oleh Bank.
                </li>
                <li>
                  Apabila nasabah menolak memberikan informasi dan dokumen pendukung yang diperlukan, maka Bank dapat menolak untuk melaksanakan transaksi dan atau
                  mengakhiri hubungan usaha dengan nasabah.
                </li>
                <li>
                  Penutupan tabungan yang dilakukan sebelum saldo mengendap selama 1 (satu) bulan terhitung sejak setoran pertama tidak diperhitungkan bunga.
                </li>
                <li>
                  Dalam hal Penabung meninggal dunia, maka pembayaran oleh Bank dapat dilakukan kepada ahli waris Penabung dengan disertai surat keterangan ahli
                  waris yang telah disahkan oleh instansi terkait sesuai undang-undang yang berlaku dan surat keterangan kematian Penabung serta dokumen-dokumen
                  pendukung lainnya.
                </li>
              </ol>
            </li>
            <li class="menu">
              PERUBAHAN-PERUBAHAN
              <div style="font-weight:normal; margin-bottom:5px">
                Bank berhak mengubah syarat-syarat umum ini, dan perubahan tersebut akan diberitahukan secara tertulis atau melalui pengumuman di seluruh Cabang BAGI
                kepada para pemegang rekening tabungan.
              </div>
            </li>
            <li class="menu">
              LAIN-LAIN
              <ol type="a" class="sub-menu">
                <li>
                  Besarnya setoran awal, setoran minimal, saldo minimal tabungan, biaya administrasi bulanan, biaya penutupan tabungan serta uku bunga ditentukan
                  oleh Bank. Apabila terjadi perubahan atas ketentuan tersebut, maka perubahan tersebut segera diberlakukan atas tabungan saat berlakunya ketentuan
                  tersebut, dengan pemberitahuan terlebih dahulu kepada Penabung dengan cara yang ditentukan oleh Bank.
                </li>
                <li>
                  Hal-hal yang menyangkut besaran tarif ditetapkan dalam lembar terpisah, dan nasabah dapat memperoleh informasinya melalui petugas Customer Service.
                </li>
                <li>enabung menyatakan tunduk pada segala ketentuan yang berlaku di Bank, baik yang sekarang ada maupun yang akan ada dikemudian hari.</li>
                <li>
                  Bank dibebaskan dari segala tuntutan dan kerugian yang timbul karena kehilangan/pemalsuan dan atau penyalahgunaan buku tabungan atau kartu ATM oleh
                  Penabung dan atau pihak lainnya dan hal tersebut merupakan beban dan tanggung jawab Penabung sepenuhnya.
                </li>
              </ol>
            </li>
          </ol>
          <form>
            <div class="form-group">
              <!-- <label>Saya sudah membaca dan memahami</label>
                      <input type="checkbox" checked required> -->
            </div>
          </form>
        </div>
        <div class="footer">
          <p></p>
          <p>2</p>
          <p></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fullName: String,
    dataPrint: Object,
  },
  data() {
    return {
      currentDate: "",
    };
  },
  mounted() {
    if (this.dataPrint.tanggal_diterima) {
      this.currentDate = this.dataPrint.tanggal_diterima;
    } else {
      this.currentDate = new Date();
    }
  },
};
</script>

<style scoped>
label {
  width: 100px;
}
.page {
  padding: 1cm;
  /* border: 5px red solid; */
  height: 257mm;
  /* outline: 2cm #FFFFFF solid; */
}

.format-text {
  text-transform: capitalize;
}

.format-text::first-letter,
.format-text::first-line {
  text-transform: capitalize;
}

.wrap-document {
  /* width: 210mm; */
  min-height: 297mm;
  padding: 10mm;
  margin: 0 auto;
  /* border: 1px #D3D3D3 solid; */
  border-radius: 5px;
  background: white;
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  position: relative;
}

.tanda-tangan {
  position: relative;
  width: 75%;
  text-align: center;
  left: 13%;
}

.menu {
  font-weight: 900;
}

.sub-menu {
  margin-left: 10px;
  margin-bottom: 5px;
  font-weight: normal;
}

.top {
  text-align: right;
  border-bottom: 1px solid #c0c0c0;
}

.img-header {
  height: 50px;
  border-left: 1px solid #c0c0c0;
  padding: 5px 0 5px 5px;
}

.header {
  display: flex;
  justify-content: space-between;
  font-size: 10px;
  margin-bottom: 25px;
}

.nomor {
  font-weight: bold;
}

.lampiran p {
  margin: 0;
  text-align: right;
}

.title {
  font-weight: bold;
  text-align: center;
  margin: 0 auto 40px;
  font-size: 14px;
}

.content {
  font-size: 12px;
  text-align: justify;
}

.sub-content {
  font-weight: 700;
}

form {
  margin: 20px 0;
  text-align: right;
  font-weight: 700;
}

label {
  margin-right: 15px;
}

.penutup {
  text-align: center;
  font-size: 12px;
}

.penutup p {
  margin: 0;
}

.resiko {
  font-weight: 700;
}

.persetujuan {
  /* width: 60%; */
  font-size: 12px;
  margin: 30px 0 90px;
  display: flex;
  justify-content: space-between;
}

.persetujuan p {
  text-align: center;
  margin-bottom: 0;
}

.persetujuan div form {
  margin: 0;
  font-weight: normal;
}

.tanggal {
  margin-left: auto;
  margin-bottom: 10px !important;
}

.jabatan {
  margin-bottom: 70px !important;
}

.pt-abi {
  display: block !important;
  margin: 20px auto;
  width: 50%;
}

.pt-abi p {
  width: auto !important;
}

.footer {
  display: flex;
  font-size: 10px;
  justify-content: space-between;
  position: absolute;
  width: 80%;
  bottom: 0;
}

.table td,
.table th {
  padding: 0.35rem;
}

@page {
  size: A4;
  margin: 0;
}
</style>
